import { ConfigurableExportField } from 'shared/react-admin/Export/ExportEditButton/ExportEditButton';

export const EXPORT_FIELDS_ADJUSTMENTS_REPORT: ConfigurableExportField[] = [
  {
    index: '0',
    source: 'id',
    label: 'ID',
  },
  {
    index: '1',
    source: 'order',
    labelKey: 'app.orderAdjustmentsReport.orderId',
  },
  {
    index: '2',
    source: 'adjustmentType',
    labelKey: 'app.orderAdjustmentsReport.adjustmentType',
  },
  {
    index: '3',
    source: 'adjustmentStatus',
    labelKey: 'app.orderAdjustmentsReport.adjustmentStatus',
  },
  {
    index: '4',
    source: 'impactToBalance',
    labelKey: 'app.orderAdjustments.balanceMovementLabel',
  },
  {
    index: '5',
    source: 'comment',
    labelKey: 'app.table.comment',
  },
  {
    index: '6',
    source: 'rejectReason',
    labelKey: 'app.orderAdjustmentsReport.rejectReason',
  },
  {
    index: '7',
    source: 'oldAmount',
    labelKey: 'app.orderAdjustmentsReport.orderAmount',
  },
  {
    index: '8',
    source: 'newAmount',
    labelKey: 'app.orderAdjustmentsReport.amountChange',
  },
  {
    index: '9',
    source: 'oldStatus',
    labelKey: 'app.orderAdjustmentsReport.orderStatus',
  },

  {
    index: '10',
    source: 'newStatus',
    labelKey: 'app.orderAdjustmentsReport.statusChange',
  },
  {
    index: '11',
    source: 'user',
    labelKey: 'app.orderAdjustmentsReport.author',
  },
  {
    index: '12',
    source: 'createdAt',
    labelKey: 'app.orderAdjustmentsReport.createdAt',
  },
  {
    index: '13',
    source: 'updatedAt',
    labelKey: 'app.orderAdjustmentsReport.appliedAt',
  },
  {
    index: '14',
    source: 'customerId',
    labelKey: 'app.orderAdjustmentsReport.clientId',
  },
  {
    index: '15',
    source: 'direction',
    labelKey: 'app.orderAdjustmentsReport.direction',
  },
  {
    index: '16',
    source: 'merchant',
    labelKey: 'app.orderAdjustmentsReport.merchant',
  },
  {
    index: '17',
    source: 'provider',
    labelKey: 'app.orderAdjustmentsReport.provider',
  },
  {
    index: '18',
    source: 'gateway',
    labelKey: 'app.orderAdjustmentsReport.gateway',
  },
  {
    index: '19',
    source: 'method',
    labelKey: 'app.orderAdjustmentsReport.method',
  },
];
